const REG_SHOPIFY_IMAGE_URL = /^(?:https?:)?(\/\/cdn\.shopify\.com\/.+?)(?:_(\d{0,4})x(\d{0,4}))?(?:_crop_(center|bottom|top|left|right)?)?(?:@(\d)x)?\.(jpe?g|webp|png|svg|gif)(?:\.(jpe?g|webp|png|svg|gif))?(\?.*)?$/i
const SHOPIFY_HOST = '//cdn.shopify.com'

const parseShopifyImageUrl = src => {
  const matched = REG_SHOPIFY_IMAGE_URL.exec(src)

  if (!matched) {
    return {
      matched: false
    }
  }

  const [
    originalSrc,
    srcPath,
    maxWidth,
    maxHeight,
    crop,
    scale,
    originalFileType,
    targetFileType,
    srcQuery
  ] = matched

  return {
    matched: true,
    originalSrc,
    srcPath,
    maxWidth,
    maxHeight,
    crop,
    scale,
    originalFileType,
    targetFileType,
    srcQuery
  }
}

// https://cdn.shopify.com/s/files/1/0140/6858/0410/products/1.1_9d719aa5-b700-4136-96ea-5f22acbcf888_333x.jpg?v=1552047839
// https://cdn.shopify.com/s/files/1/0140/6858/0410/products/1.1_9d719aa5-b700-4136-96ea-5f22acbcf888_333x.jpg.webp?v=1552047839

const genShopifyImageUrl = ({
  srcPath,
  originalFileType,
  targetFileType,
  srcQuery = '',
  maxWidth
}) => {
  if (targetFileType) {
    return `https:${srcPath}_${maxWidth}x.${originalFileType}.${targetFileType}${srcQuery}`
  }

  return `https:${srcPath}_${maxWidth}x.${originalFileType}${srcQuery}`
}


const isShopifyImageUrl = src => src.indexOf(SHOPIFY_HOST) > -1

const adjustShopifyImageUrl = (url, { maxWidth, fileType } = {}) => {
  const params = parseShopifyImageUrl(url)

  if (!params.matched) {
    return url
  }

  return genShopifyImageUrl({
    srcPath: params.srcPath,
    srcQuery: params.srcQuery,
    originalFileType: params.originalFileType,
    maxWidth: maxWidth,
    targetFileType: fileType || params.targetFileType
  })
}

export {
  isShopifyImageUrl,
  adjustShopifyImageUrl
}
